import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import { useStyles } from './SearchResultPlaceholder.styles';

const SearchResultPlaceholder = () => {
  const styles = useStyles();
  return (
    <Card
      style={{ height: '100%', width: '100%', minHeight: '236px' }}
      className={styles.container}
    >
      <Box className={styles.placeholderTopSection}>
        <Box display="flex" alignItems="flex-start">
          <Skeleton
            height={140}
            width={115}
            animation="wave"
            style={{ marginTop: '-22px' }}
          />
          <Box width="100%" ml={1}>
            <Skeleton
              className={styles.placeholderPadding}
              height={48}
              width={208}
              animation="wave"
            />
            <Skeleton
              className={styles.placeholderPadding}
              height={24}
              animation="wave"
            />
            <Skeleton
              className={styles.placeholderPadding}
              height={24}
              animation="wave"
            />
            <Skeleton
              className={styles.placeholderPadding}
              height={24}
              animation="wave"
            />
          </Box>
        </Box>
      </Box>
      <Box pt={1} pl={3} pr={3} className={styles.placeholderBottomSection}>
        <Skeleton
          className={styles.placeholderPadding}
          height={24}
          animation="wave"
        />
        <Skeleton
          className={styles.placeholderPadding}
          height={24}
          animation="wave"
        />
      </Box>
    </Card>
  );
};

export default SearchResultPlaceholder;
